"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var Input_1 = require("./Input");
var styles_1 = require("../../styles");
var DivForTextAarea = (0, styled_components_1.default)(Input_1.Div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > label {\n    top: 0;\n    bottom: auto;\n  }\n"], ["\n  > label {\n    top: 0;\n    bottom: auto;\n  }\n"])));
var TextAreaStyled = (0, styled_components_1.default)(framer_motion_1.motion.textarea)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: transparent;\n  border-bottom: 1px solid rgba(0, 0, 0, .3);\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  min-height: ", ";\n  outline: none;\n  overflow-y: hidden;\n  padding-top: ", ";\n  padding-bottom: 8.5px;\n  resize: none;\n  transition: 250ms height linear;\n  width: 100%;\n\n  ", "\n\n  ", "\n"], ["\n  background-color: transparent;\n  border-bottom: 1px solid rgba(0, 0, 0, .3);\n  border-left: none;\n  border-right: none;\n  border-top: none;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  min-height: ", ";\n  outline: none;\n  overflow-y: hidden;\n  padding-top: ", ";\n  padding-bottom: 8.5px;\n  resize: none;\n  transition: 250ms height linear;\n  width: 100%;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.family;
}, (0, styles_1.getRelative)(18, 'mobile'), (0, styles_1.getRelative)(25, 'mobile'), (0, styles_1.getRelative)(18, 'mobile'), (0, styles_1.getRelative)(5, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n    min-height: ", ";\n    padding-top: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n    min-height: ", ";\n    padding-top: ", ";\n  "])), (0, styles_1.getRelative)(18, 'desktop'), (0, styles_1.getRelative)(25, 'desktop'), (0, styles_1.getRelative)(18, 'desktop'), (0, styles_1.getRelative)(5, 'desktop')), function (_a) {
    var placeholderActive = _a.placeholderActive;
    return placeholderActive ? (0, Input_1.parsePlaceHolder)("opacity: .3;") : (0, Input_1.parsePlaceHolder)("opacity: 0;");
});
var labelTransition = {
    type: 'tween',
    duration: .3,
    ease: [.25, .1, .25, 1],
};
var variantsLabel = {
    active: function (mobile) { return ({
        opacity: 1,
        y: mobile ? (0, styles_1.getRelative)(5, 'mobile') : (0, styles_1.getRelative)(5, 'desktop'),
        fontSize: mobile ? (0, styles_1.getRelative)(10, 'mobile') : (0, styles_1.getRelative)(10, 'desktop'),
        lineHeight: mobile ? (0, styles_1.getRelative)(10, 'mobile') : (0, styles_1.getRelative)(10, 'desktop'),
        // textTransform: 'uppercase',
        transition: labelTransition
    }); },
    inactive: function (mobile) { return ({
        opacity: .4,
        y: mobile ? (0, styles_1.getRelative)(18, 'mobile') : (0, styles_1.getRelative)(18, 'desktop'),
        fontSize: mobile ? (0, styles_1.getRelative)(18, 'mobile') : (0, styles_1.getRelative)(18, 'desktop'),
        lineHeight: mobile ? (0, styles_1.getRelative)(25, 'mobile') : (0, styles_1.getRelative)(25, 'desktop'),
        textTransform: 'initial',
        transition: labelTransition
    }); }
};
exports.TextArea = (0, react_1.memo)((0, react_1.forwardRef)(function (_a, ref) {
    var name = _a.name, _b = _a.reset, reset = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? 'Label' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.initialInputState, initialInputState = _e === void 0 ? Input_1.DEFAULT_INPUT_STATE : _e, _f = _a.initialValue, initialValue = _f === void 0 ? '' : _f, _g = _a.onChange, onChange = _g === void 0 ? null : _g, _h = _a.onBlur, onBlur = _h === void 0 ? null : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, _k = _a.error, error = _k === void 0 ? false : _k, _l = _a.className, className = _l === void 0 ? '' : _l, _m = _a.onFocus, onFocus = _m === void 0 ? null : _m, _o = _a.errorMessage, errorMessage = _o === void 0 ? '' : _o, _p = _a.infoMessage, infoMessage = _p === void 0 ? '' : _p, _q = _a.maxLength, maxLength = _q === void 0 ? 190 : _q, _r = _a.rows, rows = _r === void 0 ? 1 : _r;
    var _s = __read((0, react_1.useState)(initialValue), 2), value = _s[0], setValue = _s[1];
    var _t = __read((0, react_1.useState)(initialInputState), 2), inputState = _t[0], setState = _t[1];
    var hover = inputState.hover, focus = inputState.focus, activated = inputState.activated;
    var handleChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        onChange && onChange(target.value, target.value);
        setValue(target.value);
        target.style.height = 'auto';
        target.style.height = target.scrollHeight + 'px';
    }, [onChange]);
    var handleStateChange = (0, react_1.useCallback)(function (keys, values) { return function () {
        var _a, _b;
        var newState = __assign({}, inputState);
        if (typeof keys === 'string') {
            newState = __assign(__assign({}, newState), (_a = {}, _a[keys] = values, _a));
        }
        else {
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var value_1 = values[i];
                newState = __assign(__assign({}, newState), (_b = {}, _b[key] = value_1, _b));
            }
        }
        setState(newState);
    }; }, [inputState]);
    var handleInputFocus = (0, react_1.useCallback)(function () {
        onFocus && onFocus();
        handleStateChange('focus', true)();
    }, []);
    var handleOnBlur = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        onBlur && onBlur(target.value, target.value);
        handleStateChange('focus', false)();
        handleStateChange('activated', target.value.length > 0)();
    }, []);
    (0, react_1.useEffect)(function () {
        if (reset) {
            setValue(initialValue);
            handleStateChange('activated', initialValue.length > 0)();
        }
    }, [reset]);
    (0, react_1.useEffect)(function () {
        if (initialValue || initialValue === '') {
            initialValue;
            handleStateChange('activated', initialValue.length > 0)();
        }
        return function () { return handleStateChange('activated', initialValue.length > 0)(); };
    }, [initialValue]);
    var labelActive = !disabled && focus || activated ? 'active' : 'inactive';
    var spanActive = !disabled && hover || focus || error ? 'active' : 'inactive';
    var placeHolderActive = focus || activated;
    return ((0, jsx_runtime_1.jsxs)(DivForTextAarea, __assign({ className: className, disable: disabled, onMouseEnter: handleStateChange('hover', true), onMouseLeave: handleStateChange('hover', false) }, { children: [(0, jsx_runtime_1.jsxs)(Input_1.Label, __assign({ error: error, active: labelActive === 'active' && focus, variants: variantsLabel, initial: ['inactive', 'active', 'inactive'], animate: labelActive }, { children: [label, " (", value.length, "/", maxLength, ")"] })), (0, jsx_runtime_1.jsx)(TextAreaStyled, { name: name, ref: ref, rows: rows, disabled: disabled, onFocus: handleInputFocus, placeholder: placeholder, onChange: handleChange, placeholderActive: placeHolderActive, defaultValue: initialValue, onBlur: handleOnBlur, maxLength: maxLength }), (0, jsx_runtime_1.jsx)(Input_1.Span, { error: error, transition: Input_1.transition, variants: Input_1.variantsSpan, animate: spanActive }), (0, jsx_runtime_1.jsx)(Input_1.P, __assign({ error: error, transition: Input_1.transition, variants: Input_1.variantsError, animate: (error || infoMessage) ? 'active' : 'inactive' }, { children: infoMessage ? infoMessage : errorMessage }))] })));
}));
var templateObject_1, templateObject_2, templateObject_3;
